import register from '@kpsys/angularjs-register';
import SearchFormController from './search-form.controller';
import SearchHistoryDataService from './search-history.data-service';
import SearchHistoryController from './search-history.controller';
import {memoryStateManagerFactory} from './memory-state-manager';
import {searchManagerFactory} from './search-manager.factory';
import {KpAvailableIntentsComponent} from './kp-available-intents/kp-available-intents.component';
import KpSearchItemUserComponent from './components/search-items/kp-search-item-user/kp-search-item-user.component';

/**
 * @ngdoc module
 * @name portaro.search
 * @module portaro.search
 */

export default register('portaro.search')
    .service(SearchHistoryDataService.serviceName, SearchHistoryDataService)
    .controller(SearchFormController.controllerName, SearchFormController)
    .controller(SearchHistoryController.controllerName, SearchHistoryController)
    .factory(memoryStateManagerFactory.factoryName, memoryStateManagerFactory)
    .factory(searchManagerFactory.factoryName, searchManagerFactory)
    .component(KpAvailableIntentsComponent.componentName, KpAvailableIntentsComponent)
    /* Search Items */
    .component(KpSearchItemUserComponent.componentName, KpSearchItemUserComponent)
    .name();
